import React, { useEffect, useMemo } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useIssueId } from '@atlassian/jira-issue-context-service';
import { designPanelEntryPoint } from '@atlassian/jira-issue-design-section/entrypoint';
import { useIssueAri } from '@atlassian/jira-issue-hooks/src/services/use-issue-ari';
import { createAri } from '@atlassian/jira-platform-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import UFOSegment from '@atlassian/jira-ufo-segment';

export const DesignPanel = () => {
	const cloudId = useCloudId();
	const issueId = useIssueId();
	const issueAri = useIssueAri();

	const siteAri = createAri({
		resourceOwner: 'jira',
		resourceType: 'site',
		resourceId: cloudId,
	});

	const entryPointParams = useMemo(
		() => ({ siteAri, issueAri, cloudId }),
		[siteAri, issueAri, cloudId],
	);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		designPanelEntryPoint,
		entryPointParams,
	);
	useEffect(() => {
		if (issueId) {
			entryPointActions.load();
		}
	}, [issueId, entryPointActions]);

	const runtimeProps = useMemo(() => ({ isExpanded: true }), []);

	return (
		<UFOSegment name="jiraIssueDesignPanel">
			<JiraEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="jiraIssueDesignPanel"
				packageName="jiraIssueViewBase"
				errorFallback="unmount"
				teamName="mdt-zora"
				runtimeProps={runtimeProps}
			/>
		</UFOSegment>
	);
};
